import * as constants from './constants';

export const getHistory = () => ({ type: constants.GET_HISTORY });
export const getHistorySuccess = (payload) => ({
  type: constants.GET_HISTORY_SUCCESS,
  payload,
});

export const getHistoryError = (payload) => ({
  type: constants.GET_HISTORY_ERROR,
  payload,
});
